<template>
    <div class="vip-box">
        <v-header></v-header>
        <router-view/>
        <v-footer></v-footer>
    </div>
</template>

<script>
  import Header from '../header/header.vue'
  import Footer from '../footer/footer.vue'

  export default {
    name: 'vip',
    data () {
      return {

      }
    },
    components:{
      vHeader:Header,
      vFooter:Footer
    },
    methods:{

    },
    computed:{

    },
    mounted(){

    },
    watch:{
      // 如果 `某个属性` 发生改变，这个属性对应的函数就会运行
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/vip/vip.vue